import React from 'react';
import styled from 'styled-components';
import RichText from '../../components/RichText';
import { DeviceContent, DevicesSectionContent } from './models';
import Title from './Title';

const s = {
  Container: styled.section`
    font-size: 14px;
    font-weight: 100;
    font-style: normal;
  `,
  Description: styled.div`
    margin-top: 10px;
    margin-bottom: 10px;
    padding: 3% 5%;
  `,
  DevicesContainer: styled.ul`
    list-style: none;
    padding: 3% 5%;
  `,
  DeviceLine: styled.li`
    display: flex;
    flex-direction: row;
    align-items: center;
    margin: 0.5em 0;
  `,
  DeviceIcon: styled.img`
    width: 50px;
    height: 50px;
    object-fit: contain;
    margin-right: 1em;
  `,
};

const Device = ({ icon, name }: DeviceContent) => (
  <s.DeviceLine>
    <s.DeviceIcon src={icon.fields.file.url} alt={name} />
    <span>{name}</span>
  </s.DeviceLine>
);

const FeesAndDeductiblesSection = ({ header, subHeader, description, devices }: DevicesSectionContent) => (
  <s.Container>
    <Title header={header} subHeader={subHeader} />
    <s.Description>
      <RichText content={description} />
    </s.Description>
    <s.DevicesContainer>
      {devices.map((d) => (
        <Device key={d.sys.id} {...d.fields} />
      ))}
    </s.DevicesContainer>
  </s.Container>
);

export default FeesAndDeductiblesSection;



// WEBPACK FOOTER //
// ./packages/smart-home-support/pages/fees-and-deductibles/FeesAndDeductiblesSection.tsx